import { AllArticlesContent } from "./AllArticlesContent"

const AllArticlesView = () => {
    return(
        <>
        <AllArticlesContent/>
        </>

    )
}

export default AllArticlesView